import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'monthToYears',
  standalone: false,
})
export class MonthToYearsPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: number): string {
    if (value == null || value < 0) {
      return '';
    }
    let year = Math.floor(value / 12);
    let month = value % 12;
    if (year >= 1 && month > 0) {
      return `${year + ' ' + this.translateService.instant('label.Year')} ${
        month + ' ' + this.translateService.instant('label.Month')
      }`;
    }
    if (year < 1 && month > 0) {
      return `${month + ' ' + this.translateService.instant('label.Month')}`;
    }
    if ((year >= 1 && month == 0) || year >= 1) {
      return `${year + ' ' + this.translateService.instant('label.Year')}`;
    }
  }
}
